/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* ------------------------------------------------------------------------
 * VIP ENTRIES ROW
 * Adds a second "entries" row under the standard entries badge on product
 * pages showing what a VIP member would receive (standard × VIP factor).
 * The standard badge is rendered by theme.js (class .entries-price.pdp); this
 * script watches for it and appends the VIP row next to it. Controlled by
 * Theme settings → entries → "VIP Entries Row". No theme.js edits needed.
 * ---------------------------------------------------------------------- */
(function () {
  if (!window.theme || window.theme.pageType !== 'product') return;

  var base = document.getElementById('entries-settings');
  var cfg = document.getElementById('entries-vip-settings');
  if (!base || !cfg) return;

  var enabled = String(base.getAttribute('data-condition')) === 'true' &&
                String(cfg.getAttribute('data-vip-condition')) === 'true';
  if (!enabled) return;

  var baseMultiplier = parseFloat(base.getAttribute('data-entries-value')) || 0;
  var factor = parseFloat(cfg.getAttribute('data-vip-factor')) || 2;
  var entriesText = base.getAttribute('data-entries-text') || 'Entries';
  var badgeText = cfg.getAttribute('data-vip-text') || 'VIP';
  var tooltip = cfg.getAttribute('data-vip-tooltip') || '';
  var link = cfg.getAttribute('data-vip-link') || '';
  var vipMultiplier = Math.round(baseMultiplier * factor);

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function parseEntries(el) {
    var valueEl = el.querySelector('.entries-value');
    if (!valueEl) return NaN;
    var m = (valueEl.textContent || '').replace(/,/g, '').match(/-?\d+(\.\d+)?/);
    return m ? parseFloat(m[0]) : NaN;
  }

  function buildRow(baseEntries) {
    var vipEntries = Math.round(baseEntries * factor);
    var row = document.createElement('span');
    row.className = 'entries-vip-row';

    var badge = link ? document.createElement('a') : document.createElement('span');
    badge.className = 'entries-vip-badge';
    badge.textContent = badgeText;
    if (tooltip) badge.setAttribute('title', tooltip);
    if (link) badge.setAttribute('href', link);

    row.innerHTML =
      '<span class="entries-price entries-vip">' +
        '<span class="entries-value"> ' + vipEntries + ' ' + esc(entriesText) + ' </span>' +
        '<span class="entries-base-animation">' + vipMultiplier + 'X</span>' +
      '</span>';
    row.appendChild(badge);
    return row;
  }

  function apply() {
    // Only the main product badge (theme.js gives it the "pdp" class);
    // recommendation cards on the same page use "default" and are left alone.
    var rows = document.querySelectorAll('.entries-vip-row');
    for (var r = 0; r < rows.length; r++) {
      var prev = rows[r].previousElementSibling;
      if (!prev || !prev.classList.contains('pdp')) rows[r].remove();
    }
    var badges = document.querySelectorAll('.entries-price.pdp');
    for (var i = 0; i < badges.length; i++) {
      var badge = badges[i];
      var baseEntries = parseEntries(badge);
      if (isNaN(baseEntries)) continue;
      var next = badge.nextElementSibling;
      if (next && next.classList.contains('entries-vip-row')) {
        if (next.getAttribute('data-base') === String(baseEntries)) continue;
        next.remove();
      }
      var row = buildRow(baseEntries);
      row.setAttribute('data-base', String(baseEntries));
      badge.insertAdjacentElement('afterend', row);
      align(badge, row);
    }
  }

  // Line the VIP row up under the standard badge so the two red multiplier
  // boxes sit in the same column: indent by the price width, and give the
  // VIP box the same width as the standard box.
  function align(badge, row) {
    var list = badge.parentElement;
    var box = row.querySelector('.entries-price');
    if (!list || !box) return;
    var b = badge.getBoundingClientRect();
    var l = list.getBoundingClientRect();
    if (!b.width) return;
    box.style.marginLeft = Math.max(0, Math.round(b.left - l.left)) + 'px';
    box.style.minWidth = Math.round(b.width) + 'px';
  }

  function realign() {
    var badges = document.querySelectorAll('.entries-price.pdp');
    for (var i = 0; i < badges.length; i++) {
      var next = badges[i].nextElementSibling;
      if (next && next.classList.contains('entries-vip-row')) align(badges[i], next);
    }
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () { scheduled = false; apply(); }, 0);
  }

  var observer = new MutationObserver(schedule);
  observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  document.addEventListener('variant:changed', schedule);
  window.addEventListener('resize', realign);
  window.addEventListener('load', realign);
  schedule();
})();
